import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Initialise KaTeX globally with mhchem (chemistry) extension before any
// react-katex InlineMath/BlockMath component ever mounts. This ensures the
// \ce{...} macro is recognised everywhere in the app (RenderContent,
// EquationStudio, SectionEquations).
import "katex/dist/katex.min.css";
import "katex/dist/contrib/mhchem.js";
import App from "@/App";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient, installWriteInvalidation } from "@/lib/queryClient";
import axios from "axios";
import { installTenantSuspensionWatcher } from "@/lib/tenantSuspension";
import { installDeviceSessionWatcher } from "@/lib/deviceSession";
import { installGlobalErrorToasts } from "@/lib/errors";

// Spot "school suspended" API replies from any fetch/axios call (see the module).
installTenantSuspensionWatcher(axios);
// Login device limit: device id on API calls + "signed in elsewhere" replies.
installDeviceSessionWatcher(axios);
// Request failures no screen handled still reach the user — as a friendly toast.
installGlobalErrorToasts();
// Saved page data goes stale after any write, so edits always show (see the module).
installWriteInvalidation(axios);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
